import { LiveSessionState } from "@pcp/core/interfaces";
import { createReducer, on } from "@ngrx/store";
import { liveLessonStateActions } from "./live-lesson-state.actions";

export const featureKey = "liveLessonState";

export interface State {
    liveLessonState?: LiveSessionState;
    isLoading: boolean;
 }

export const initialState: State = {
    liveLessonState: undefined,
    isLoading: false,
};

export const reducer = createReducer(
    initialState,

    on(liveLessonStateActions.fetchLiveLessonState, (state): State => ({
        ...state,
        isLoading: true,
    })),

    on(
        liveLessonStateActions.fetchLiveLessonStateSuccess,
        liveLessonStateActions.fetchLiveLessonStateFailed,
        (state): State => ({
            ...state,
            isLoading: false,
        })
    ),

    on(
        liveLessonStateActions.fetchLiveLessonStateSuccess,
        liveLessonStateActions.receivedStateUpdateFromSignalr,
        (state, { liveLessonState }): State => ({
            ...state,
            liveLessonState,
    })),
);
